/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetReportDefinitionByIdQueryResponse, AuditReportsGetReportDefinitionByIdPathParams, AuditReportsGetReportDefinitionById401, AuditReportsGetReportDefinitionById403, AuditReportsGetReportDefinitionById404 } from "../models/AuditReportsGetReportDefinitionById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsGetReportDefinitionById } from "../axios/auditReportsGetReportDefinitionById";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsGetReportDefinitionByIdQueryKey = (id: AuditReportsGetReportDefinitionByIdPathParams["id"]) => ["api-v2", { url: '/audit-reports/v1/report-definitions/by-id/:id', params: {id:id} }] as const

export type AuditReportsGetReportDefinitionByIdQueryKey = ReturnType<typeof auditReportsGetReportDefinitionByIdQueryKey>

export function auditReportsGetReportDefinitionByIdQueryOptions(id: AuditReportsGetReportDefinitionByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsGetReportDefinitionByIdQueryKey(id)
        return queryOptions<AuditReportsGetReportDefinitionByIdQueryResponse, ResponseErrorConfig<AuditReportsGetReportDefinitionById401 | AuditReportsGetReportDefinitionById403 | AuditReportsGetReportDefinitionById404>, AuditReportsGetReportDefinitionByIdQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsGetReportDefinitionById(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Retrieves a specific report definition by its unique identifier
 * @summary Get report definition by ID
 * {@link /audit-reports/v1/report-definitions/by-id/:id}
 */
export function useAuditReportsGetReportDefinitionById<TData = AuditReportsGetReportDefinitionByIdQueryResponse, TQueryData = AuditReportsGetReportDefinitionByIdQueryResponse, TQueryKey extends QueryKey = AuditReportsGetReportDefinitionByIdQueryKey>(id: AuditReportsGetReportDefinitionByIdPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsGetReportDefinitionByIdQueryResponse, ResponseErrorConfig<AuditReportsGetReportDefinitionById401 | AuditReportsGetReportDefinitionById403 | AuditReportsGetReportDefinitionById404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsGetReportDefinitionByIdQueryKey(id)
         

         const query = useQuery({
          ...auditReportsGetReportDefinitionByIdQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsGetReportDefinitionById401 | AuditReportsGetReportDefinitionById403 | AuditReportsGetReportDefinitionById404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}